module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "centered"
  }, [_vm._v("Your session expired. Please reload the window.")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6314c2c9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoggedOut.vue
// module id = 542
// module chunks = 1